import { BasketCalculatedLineViewModel } from '@models/api-orders.models';

import { Product } from '../model';
import { calculateRemoveLineTotal } from '@utils/gtm-tracking/utils/calculateLineTotal';
import { mapToBasketAddRemoveTrackableProduct } from '@utils/gtm-tracking/utils/mapToBasketAddRemoveTrackableProduct';

export type RemoveFromBasketEvent = {
    event: 'remove_from_cart';
    ecommerce: {
        currency: string;
        value: number;
        items: Product[];
    };
};

export const trackRemoveFromBasketEvent = (
    products: BasketCalculatedLineViewModel[],
    currency: string = 'DKK'
): RemoveFromBasketEvent => ({
    event: 'remove_from_cart',
    ecommerce: {
        currency,
        value: products.reduce((total, product) => calculateRemoveLineTotal(total, product), 0),
        items: products.map(product => mapToBasketAddRemoveTrackableProduct(product))
    }
});
